export const ZBO_PRIPAD_QUERY_KEY = 'ZBO_PRIPAD_QUERY_KEY';
//# sourceMappingURL=query.js.map